import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Container } from '@mui/material';
import { copapp, shiftwave, trackDownload } from '../../utils/downloads';
import './Footer.scss';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <Container maxWidth="lg">
                <div className="site-footer__grid">
                    <div className="site-footer__brand">
                        <RouterLink to="/" className="site-footer__logo">
                            <img src="/images/planet-logo-dark-128.png" alt="" width={28} height={28} />
                            <span>MyProjectX</span>
                        </RouterLink>
                        <p>Simple, dependable schedule apps for people who work shifts.</p>
                    </div>

                    <div>
                        <h3>ShiftWave</h3>
                        <a href={shiftwave.appStoreLink} target="_blank" rel="noopener noreferrer" onClick={() => trackDownload('shiftwave', 'appstore', 'footer')}>App Store</a>
                        <a href={shiftwave.googlePlayLink} target="_blank" rel="noopener noreferrer" onClick={() => trackDownload('shiftwave', 'googleplay', 'footer')}>Google Play</a>
                        <a href="/shiftwave/privacy.htm">Privacy Policy</a>
                    </div>

                    <div>
                        <h3>CopApp!</h3>
                        <a href={copapp.appStoreLink} target="_blank" rel="noopener noreferrer" onClick={() => trackDownload('copapp', 'appstore', 'footer')}>App Store</a>
                        <a href={copapp.googlePlayLink} target="_blank" rel="noopener noreferrer" onClick={() => trackDownload('copapp', 'googleplay', 'footer')}>Google Play</a>
                        <a href="/copapp/help.htm">Help</a>
                        <a href="/copapp/tos.htm">Terms</a>
                    </div>

                    <div>
                        <h3>Company</h3>
                        <RouterLink to="/about">About</RouterLink>
                        <RouterLink to="/contact">Contact</RouterLink>
                        <a href="mailto:myprojectxinc@gmail.com">myprojectxinc@gmail.com</a>
                        <a href="/privacy.html">Privacy Policy</a>
                    </div>
                </div>

                <div className="site-footer__bottom">
                    <span>© {currentYear} MyProjectX, Inc. All rights reserved.</span>
                    <span>Apple and the App Store are trademarks of Apple Inc. Google Play is a trademark of Google LLC.</span>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;
